import { useEffect, useState } from 'react';
import { Outlet, useLocation, useNavigate, useOutletContext } from 'react-router-dom';
import type { Tenant } from '@/lib/tenant';
import { demoMode } from '@/lib/api';
import { isOwnerAuthenticated, isOwnerUnlocked } from '@/lib/ownerAuth';

// Каркас админки. Страница входа (/admin) открыта, всё глубже (/admin/*)
// требует входа владельца: демо — код доступа, прод — D1-сессия.
// TenantLayout остаётся выше; tenant-контекст пробрасываем вниз вручную,
// иначе OwnerEntry/OwnerDashboard не получат салон.
export function AdminLayout() {
  const { tenant } = useOutletContext<{ tenant: Tenant }>();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const isEntry = pathname === '/admin' || pathname === '/admin/';

  // Демо решается синхронно, прод — асинхронно (серверная сессия).
  const [allowed, setAllowed] = useState<boolean | null>(demoMode ? isOwnerUnlocked() : null);

  useEffect(() => {
    if (isEntry) return;
    if (demoMode) {
      const unlocked = isOwnerUnlocked();
      setAllowed(unlocked);
      if (!unlocked) navigate('/admin', { replace: true });
      return;
    }
    let alive = true;
    void isOwnerAuthenticated().then((ok) => {
      if (alive) setAllowed(ok);
    });
    return () => {
      alive = false;
    };
  }, [isEntry, navigate, pathname]);

  useEffect(() => {
    if (!demoMode && !isEntry && allowed === false) navigate('/admin', { replace: true });
  }, [isEntry, allowed, navigate]);

  if (isEntry) return <Outlet context={{ tenant }} />;

  if (allowed === null) {
    return (
      <main className="mnc-page">
        <p className="mnc-muted">Проверяем доступ…</p>
      </main>
    );
  }

  if (!allowed) {
    return (
      <main className="mnc-page">
        <p className="mnc-muted">Переходим ко входу…</p>
      </main>
    );
  }

  return <Outlet context={{ tenant }} />;
}
